module.exports = __webpack_public_path__ + "img/footer.13b5d79b.png";